/**
* First we will load all of this project's JavaScript dependencies which
* includes Vue and other libraries. It is a great starting point when
* building robust, powerful web applications using Vue and Laravel.
*/

require('./bootstrap');
window.$ = window.jQuery = require('jquery');

// window.Vue = require('vue');
import Vue from 'vue';
window.Vue = Vue;
Vue.config.performance = true;
import store from './store'
import { mapGetters, mapActions } from 'vuex'
$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});
/**
* Next, we will create a fresh Vue application instance and attach it to
* the page. Then, you may begin adding components to this application
* or customize the JavaScript scaffolding to fit your unique needs.
*/
import VueTimeago from 'vue-timeago'

Vue.use(VueTimeago, {
  locale: 'en-US',
  locales: { 'en-US': require('vue-timeago/locales/en-US.json') }
})

import vueSignature from "vue-signature"
Vue.use(vueSignature);
createDpiTestElements();
import VeeValidate, { Validator } from 'vee-validate'
import validationDynamicLocale from "./dynamic-locale";
import { filterDecimalInput } from './helpers/decimalFilter';
import { applyEnrichmentToState } from './helpers/addressEnrichmentAutofill';
import { normalizeIban, isValidIban } from './helpers/ibanValidation';
import { deriveBicForIban, applyBicAutofill, isAutofillEcho } from './helpers/bicAutofill';
import * as uploadDocumentsScrollRestore from './helpers/uploadDocumentsScrollRestore';

// Expose the shared live decimal sanitizer so raw (non-ThemeInput) landlord
// inputs (add-house garden/balcony/roof) can reuse the exact same rules.
window.filterDecimalInput = filterDecimalInput;
// Same reasoning: add-house.blade.php's Vue instance is inline Blade script, not an importable
// module, so the BAG area/construction_year autofill decision logic is exposed here instead.
window.applyEnrichmentToState = applyEnrichmentToState;
// sign-pdf-attachment.blade.php's onSepaIbanBlur BIC-autofill logic is inline Blade script too -
// same reasoning as applyEnrichmentToState above.
window.deriveBicForIban = deriveBicForIban;
window.applyBicAutofill = applyBicAutofill;
window.isAutofillEcho = isAutofillEcho;
// upload-documents.blade.php's tab-restore/scroll-restore logic is inline Blade script too -
// exposed here so it stays unit-testable instead of living only in the page.
window.uploadDocumentsScrollRestore = uploadDocumentsScrollRestore;
import queryString from 'query-string';
import _ from 'lodash';
import fancybox from '@fancyapps/fancybox';
// P3: one delegated, idempotent public property-photo save-deterrence module (public bundle only).
import './modules/property-photo-protection';
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/images/empty.png',
  loading: '/images/loading.gif',
  attempt: 1
})
import VueDirectiveTooltip from 'vue-directive-tooltip'
Vue.use(VueDirectiveTooltip);
import sweetalert from 'sweetalert';

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY HH:mm:ss');
  }
});

Vue.filter('formatDate1', function (value) {
  if (value) {
    return moment(String(value)).format('DD-MM-YYYY');
  } else {
    return '-';
  }
});

Vue.filter('formatDate2', function (value) {
  if (value) {
    var lang = document.querySelector('body').getAttribute('data-lang');
    moment.locale(lang);
    // console.log(String(value), moment(String(value)));
    return moment(String(value)).format('MMM DD, YYYY');
  } else {
    return '-';
  }
});

Vue.filter('formatDate3', function (value) {
  if (value) {
    var lang = document.querySelector('body').getAttribute('data-lang');
    moment.locale(lang);
    return moment(String(value), 'DD-MM-YYYY').format('MMM DD, YYYY');
  } else {
    return '-';
  }
});


Validator.localize({ validationDynamicLocale: validationDynamicLocale });
Vue.use(VeeValidate, { locale: 'validationDynamicLocale', inject: false, classes: true });
import 'select2/dist/css/select2.css';
Vue.component('rental-listing', require('./components/RentalListing.vue').default);
Vue.component('landlord-journey-panel', require('./components/LandlordJourneyPanel.vue').default);
Vue.component('landlord-journey-hud', require('./components/LandlordJourneyHud.vue').default);
Vue.component('assignment-scanner', require('./components/AssignmentScanner.vue').default);
Vue.component('map-search', require('./components/MapSearch.vue').default);
Vue.component('map-searches', require('./components/MapSearches.vue').default);
Vue.component('favorites-counter', require('./components/FavoritesCounter.vue').default);
Vue.component('tour', require('./components/Tour.vue').default);
Vue.component('appointment-planner', require('./components/AppointmentPlanner.vue').default);
Vue.component('matches-listing', require('./components/MatchesListing.vue').default);
Vue.component('hamburger', require('vue-hamburger').default);
Vue.component('message-form', require('./components/MessageForm.vue').default);
Vue.component('v-members-tabs', require('./admin/components/VMembersTabs.vue').default);
Vue.component('v-autocomplete', require('./admin/components/VAutocomplete.vue').default);
Vue.component('v-form-list-replicator', require('./admin/components/VFormListReplicator.vue').default);
Vue.component('v-textfield', require('./admin/components/VTextfield').default);
Vue.component('v-checkboxes', require('./admin/components/VCheckboxes').default);
Vue.component('v-radios', require('./admin/components/VRadios').default);
Vue.component('v-select', require('./admin/components/VSelect').default);
Vue.component('v-select-search', require('./admin/components/VSelectSearch').default);
Vue.component('v-details-form', require('./admin/components/VDetailsForm').default);
Vue.component('v-details-inner-form', require('./admin/components/VDetailsInnerForm.vue').default);
Vue.component('v-textfield-public', require('./admin/components/VTextfieldPublic').default);
Vue.component('v-checkboxes-public', require('./admin/components/VCheckboxesPublic').default);
Vue.component('v-radios-public', require('./admin/components/VRadiosPublic').default);
Vue.component('v-select-public', require('./admin/components/VSelectPublic.vue').default);
Vue.component('v-datepicker-public', require('./admin/components/VDatepickerPublic').default);
Vue.component('v-datepicker', require('./admin/components/VDatepicker').default);
Vue.component('v-datepicker-visible', require('./admin/components/VDatepickerVisible.vue').default);
Vue.component('v-subscribe-form', require('./admin/components/VSubscribeForm').default);
Vue.component('v-subscribe-inner-form', require('./admin/components/VSubscribeInnerForm.vue').default);
Vue.component('v-search-profile-form', require('./admin/components/VSearchProfileForm.vue').default);
Vue.component('v-autocomplete-public', require('./admin/components/VAutocompletePublic.vue').default);
Vue.component('v-autocomplete-custom', require('./admin/components/VAutocompleteCustom').default);
Vue.component('v-form-public', require('./admin/components/VFormPublic').default);
Vue.component('v-textarea-public', require('./admin/components/VTextareaPublic').default);
Vue.component('v-contact-form', require('./admin/components/VContactForm').default);
Vue.component('v-let-form', require('./admin/components/VLetForm').default);
Vue.component('v-manage-form', require('./admin/components/VManageForm').default);
Vue.component('v-let-sh-form', require('./admin/components/VLetShForm').default);
Vue.component('v-gallery', require('./admin/components/VGallery').default);
Vue.component('v-wysiwyg', require('./admin/components/VWysiwyg').default);
Vue.component('v-tabs', require('./admin/components/VTabs').default);
Vue.component('v-card', require('./admin/components/VCard').default);
Vue.component('v-date-filter', require('./admin/components/VDateFilter').default);
Vue.component('v-table-body', require('./admin/components/VTableBody').default);
Vue.component('v-status-toggler', require('./admin/components/VStatusToggler').default);
Vue.component('v-status-changer', require('./admin/components/VStatusChanger').default);
Vue.component('v-date-filter-public', require('./admin/components/VDateFilterPublic').default);
Vue.component('v-numeric-field-public', require('./admin/components/VNumericFieldPublic').default);
Vue.component('v-signature', require('./admin/components/VSignature').default);
Vue.component('video-player', require('./components/VideoPlayer.vue').default);
Vue.component('v-gallery-inspections-public', require('./admin/components/VGalleryInspectionsPublic.vue').default);
Vue.component('notifications-subscribe', require('./components/NotificationsSubscribe').default);
Vue.component('push-notifications-panel', require('./components/PushNotificationsPanel').default);
// Shared late-cancellation handshake for the inline Blade scripts (My Viewings, property page).
window.viewingSignOut = require('./helpers/viewingSignOut');
Vue.component('visitor-notifications', require('./components/VisitorNotifications.vue').default);
Vue.component('booking-form', require('./components/BookingForm.vue').default);

Vue.component('notifications-dropdown', require('./components/NotificationsDropdown').default);
Vue.component('infinite-scroll', require('./components/InfiniteScroll.vue').default);
Vue.component('login', require('./components/Login.vue').default);
Vue.component('login-form', require('./components/LoginForm.vue').default);
Vue.component('password-form', require('./components/PasswordForm.vue').default);
Vue.component('main-search', require('./components/MainSearch.vue').default);
Vue.component('work-flow', require('./components/WorkFlow.vue').default);
Vue.component('faq', require('./components/FAQ.vue').default);
Vue.component('signup', require('./components/Signup.vue').default);
Vue.component('theme-input', require('./components/ThemeInput.vue').default);
Vue.component('theme-checkboxes', require('./components/ThemeCheckboxes.vue').default);
Vue.component('theme-filter-checkboxes', require('./components/ThemeFilterCheckboxes.vue').default);
Vue.component('theme-radios', require('./components/ThemeRadios.vue').default);
Vue.component('theme-calendar', require('./components/ThemeCalendar.vue').default);
Vue.component('theme-toggler', require('./components/ThemeToggler.vue').default);
Vue.component('theme-location-dropdown', require('./components/ThemeLocationDropdown.vue').default);
Vue.component('theme-select', require('./components/ThemeSelect.vue').default);
Vue.component('theme-numeric', require('./components/ThemeNumeric.vue').default);
Vue.component('theme-autocomplete', require('./components/ThemeAutocomplete.vue').default);
Vue.component('energy-label-alert-notice', require('./components/EnergyLabelAlertNotice.vue').default);
Vue.component('theme-autocomplete-custom', require('./components/ThemeAutocompleteCustom.vue').default);
Vue.component('pdok-address-typeahead', require('./components/PdokAddressTypeahead.vue').default);
Vue.component('google-address-typeahead', require('./components/GoogleAddressTypeahead.vue').default);
Vue.component('international-address-field', require('./components/InternationalAddressField.vue').default);
Vue.component('theme-textarea', require('./components/ThemeTextarea.vue').default);
Vue.component('theme-file', require('./components/ThemeFile.vue').default);
Vue.component('theme-download', require('./components/ThemeDownload.vue').default);
Vue.component('theme-tour', require('./components/ThemeTour.vue').default);
Vue.component('theme-districts-dropdown', require('./components/ThemeDistrictsDropdown.vue').default);
Vue.component('theme-form-public', require('./components/ThemeFormPublic.vue').default);
Vue.component('theme-form-list-replicator', require('./components/ThemeFormListReplicator.vue').default);
Vue.component('theme-notifications', require('./components/ThemeNotifications.vue').default);
Vue.component('theme-wysiwyg', require('./components/ThemeWysiwyg.vue').default);
Vue.component('theme-gallery', require('./components/ThemeGallery.vue').default);
Vue.component('account-details-outer-form', require('./components/AccountDetailsOuterForm.vue').default);
Vue.component('account-details-inner-form', require('./components/AccountDetailsInnerForm.vue').default);
Vue.component('search-preferences-form', require('./components/SearchPreferencesForm.vue').default);
Vue.component('search-preferences-form-sh', require('./components/SearchPreferencesFormSH.vue').default);
Vue.component('registration-form', require('./components/RegistrationForm.vue').default);
Vue.component('registration-inner-form', require('./components/RegistrationInnerForm.vue').default);
Vue.component('registration-form-sh', require('./components/RegistrationFormSH.vue').default);
Vue.component('rent-property-form', require('./components/RentPropertyForm.vue').default);
Vue.component('vuuro-landlord-onboarding-wizard', require('./components/VuuroLandlordOnboardingWizard.vue').default);
Vue.component('rental-form-video-uploader', require('./components/RentalFormVideoUploader.vue').default);
Vue.component('property-media-preview-bridge', require('./components/PropertyMediaPreviewBridge.vue').default);
Vue.component('property-edit-video-uploader', require('./components/PropertyEditVideoUploader.vue').default);
Vue.component('landlord-media-batch-progress', require('./components/LandlordMediaBatchProgress.vue').default);
Vue.component('landlord-property-section-nav', require('./components/LandlordPropertySectionNav.vue').default);
Vue.component('breadcrumbs', require('./components/Breadcrumbs.vue').default);
Vue.component('property-search-control', require('./components/PropertySearchControl.vue').default);
Vue.component('active-profile-search-control', require('./components/ActiveProfileSearchControl.vue').default);
Vue.component('properties-listing', require('./components/PropertiesListing.vue').default);
Vue.component('properties-map', require('./components/PropertiesMap.vue').default);
Vue.component('searches-map', require('./components/SearchesMap.vue').default);
Vue.component('searchprofiles-listing', require('./components/SearchprofilesListing.vue').default);
Vue.component('schedule-flow', require('./components/ScheduleFlow.vue').default);
Vue.component('schedule-flow-login', require('./components/ScheduleFlowLogin.vue').default);
Vue.component('schedule-flow-viewing', require('./components/ScheduleFlowViewing.vue').default);
Vue.component('schedule-flow-confirmation', require('./components/ScheduleFlowConfirmation.vue').default);
Vue.component('v-document-card', require('./components/VDocumentCard.vue').default);
Vue.component('booking-widget', require('./components/BookingWidget.vue').default);
Vue.component('message-widget', require('./components/MessageWidget.vue').default);
Vue.component('v-tenant-form', require('./components/VTenantForm.vue').default);
Vue.component('contact-form', require('./components/ContactForm.vue').default);
Vue.component('v-recaptcha', require('./admin/components/VRecaptcha.vue').default);
Vue.component('manage-bookings-catalog', require('./components/ManageBookingsCatalog.vue').default);
Vue.component('my-bookings-catalog', require('./components/MyBookingsCatalog.vue').default);
Vue.component('v-lightcase-holder', require('./admin/components/VLightcaseHolder').default);
Vue.component('booking-details-document', require('./components/BookingDetailsDocument.vue').default);
Vue.component('booking-details-dates-modal', require('./components/BookingDetailsDatesModal.vue').default);
Vue.component('booking-details-guests-modal', require('./components/BookingDetailsGuestsModal.vue').default);
Vue.component('theme-details-form', require('./components/ThemeDetailsForm.vue').default);
Vue.component('theme-details-inner-form', require('./components/ThemeDetailsInnerForm.vue').default);
Vue.component('favorites-listing', require('./components/FavoritesListing.vue').default);
Vue.component('manage-properties-status', require('./components/ManagePropertiesStatus.vue').default);
Vue.component('booking-details-landlord-document', require('./components/BookingDetailsDocumentLandlord.vue').default);
Vue.component('independant-form', require('./components/IndependantForm.vue').default);
Vue.component('dependant-form', require('./components/DependantForm.vue').default);
Vue.component('theme-calendar-with-buttons', require('./components/ThemeCalendarWithButtons.vue').default);
Vue.component('v-facility-form-public', require('./components/VFacilityFormPublic.vue').default);
Vue.component('appointment-date-time-modal', require('./components/AppointmentDateTimeModal.vue').default);
Vue.component('appointment-guests-modal', require('./components/AppointmentGuestsModal.vue').default);
Vue.component('theme-multiple-files', require('./components/ThemeMultipleFiles.vue').default);
Vue.component('rent-property-sh-form', require('./components/RentPropertyShForm.vue').default);
Vue.component('theme-manage-form', require('./components/ThemeManageForm.vue').default);
Vue.component('dependant-form-new', require('./components/DependantFormNew.vue').default);
Vue.component('independant-form-new', require('./components/IndependantFormNew.vue').default);
Vue.component('booking-form', require('./components/BookingForm.vue').default);


Validator.extend('min.string', {
  getMessage: (field, [min]) => window.app.locales.validation.min.string.replace(":attribute", field).replace(":min", min),
  validate: (value, [min]) => {
    return value.length >= min;
  }
});

Validator.extend('min.numeric', {
  getMessage: (field, [min]) => window.app.locales.validation.min.numeric.replace(":attribute", field).replace(":min", min),
  validate: (value, [min]) => {
    return +value >= min;
  }
});

Validator.extend('min.array', {
  getMessage: (field, [min]) => window.app.locales.validation.min.array.replace(":attribute", field).replace(":min", min),
  validate: (value, [min]) => {
    return value.length >= min;
  }
});

Validator.extend('max.string', {
  getMessage: (field, [max]) => window.app.locales.validation.max.string.replace(":attribute", field).replace(":max", max),
  validate: (value, [max]) => {
    return value.length <= max;
  }
});

Validator.extend('max.numeric', {
  getMessage: (field, [max]) => window.app.locales.validation.max.numeric.replace(":attribute", field).replace(":max", max),
  validate: (value, [max]) => {
    return +value <= max;
  }
});

Validator.extend('max.array', {
  getMessage: (field, [max]) => window.app.locales.validation.max.array.replace(":attribute", field).replace(":max", max),
  validate: (value, [max]) => {
    return value.length <= max;
  }
});

Validator.extend('between.string', {
  getMessage: (field, [min, max]) => window.app.locales.validation.between.string.replace(":attribute", field).replace(":min", min).replace(":max", max),
  validate: (value, [min, max]) => {
    return max >= value.length >= min;
  }
});

Validator.extend('between.numeric', {
  getMessage: (field, [min, max]) => window.app.locales.validation.between.numeric.replace(":attribute", field).replace(":min", min).replace(":max", max),
  validate: (value, [min, max]) => {
    return max >= +value >= min;
  }
});

Validator.extend('between.array', {
  getMessage: (field, [min, max]) => window.app.locales.validation.between.array.replace(":attribute", field).replace(":min", min).replace(":max", max),
  validate: (value, [min, max]) => {
    return max >= value.length >= min;
  }
});

Validator.extend('size.string', {
  getMessage: (field, [size]) => window.app.locales.validation.size.string.replace(":attribute", field).replace(":size", size),
  validate: (value, [size]) => {
    return value.length == size;
  }
});

Validator.extend('size.numeric', {
  getMessage: (field, [size]) => window.app.locales.validation.size.numeric.replace(":attribute", field).replace(":size", size),
  validate: (value, [size]) => {
    return +value == size;
  }
});

Validator.extend('size.array', {
  getMessage: (field, [size]) => window.app.locales.validation.size.array.replace(":attribute", field).replace(":size", size),
  validate: (value, [size]) => {
    return value.length == size;
  }
});

// Additive rule for landlord decimal-capable fields (add-house area + price).
// Mirrors the server LandlordNumericInput::DECIMAL_REGEX after comma->dot
// normalization: up to 7 leading digits, one optional separator (, or .) and
// 1-2 decimals. Rejects >2 decimals, multiple/mixed separators, scientific
// notation, spaces and units. Empty is allowed (optional field). Not applied
// anywhere unless a field explicitly opts in, so other sites/forms are unaffected.
Validator.extend('decimal_separator', {
  // Use only the LTM-managed decimal key: validation.numeric's "Het :attribute
  // veld moet een nummer zijn." has the wrong grammar for a decimal field.
  getMessage: (field) => (window.app.locales.validation.decimal || '')
    .replace(":attribute", field)
    .replace(":decimals", "2"),
  validate: (value) => {
    const v = String(value == null ? '' : value);
    return v === '' || /^\d{1,7}([,.]\d{1,2})?$/.test(v);
  }
});

Validator.extend('alpha_dash', {
  getMessage: field => window.app.locales.validation.alpha_dash.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[0-9a-zA-Z _-]+$");
    return regex.test(value);
  }
});

Validator.extend('post_code', {
  getMessage: field => window.app.locales.validation.post_code.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[A-Z0-9][A-Z0-9\- ]{0,10}[A-Z0-9]$", 'i');
    return regex.test(value);
  }
});

// Local, offline structural + MOD-97 checksum check (resources/js/helpers/ibanValidation.js) -
// UX only, the backend (App\Rules\ValidIban) is authoritative regardless. Never a network call.
Validator.extend('iban', {
  getMessage: field => window.app.locales.validation.iban.replace(":attribute", field),
  validate: value => isValidIban(normalizeIban(value))
});

Validator.extend('alpha_num_spaces', {
  getMessage: field => window.app.locales.validation.alpha_num_spaces.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[0-9a-zA-Z -]+$");
    return regex.test(value);
  }
});

Validator.extend('alpha_spaces_dash', {
  getMessage: field => window.app.locales.validation.alpha_spaces_dash.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[a-zA-Z -]+$");
    return regex.test(value);
  }
});

Validator.extend('num_spaces', {
  getMessage: field => window.app.locales.validation.num_spaces.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[0-9 ]+$");
    return regex.test(value);
  }
});

Validator.extend('make_choice', {
  getMessage: field => window.app.locales.validation.make_choice.replace(":attribute", field),
  validate: value => {
    if (typeof value !== "object") {
      var regex = new RegExp("^[0-9]+$");
      return regex.test(value);
    } else {
      var result = !!value.length;
      return result;
    }
  }
});

Validator.extend('location', {
  getMessage: field => window.app.locales.validation.location.replace(":attribute", field),
  validate: value => {
    var regex = /^[0-9]*$/;
    return regex.test(value);
  }
});

// Validator.extend('locations', {
//   getMessage: field => window.app.locales.validation.location.replace(":attribute", field),
//   validate: value => {
//     return Array.isArray(value) && value.length > 0;
//   }
// });

// Define a global validator
Validator.extend('locations', {
  getMessage: function(field) {
    const validation = window.app && window.app.locales && window.app.locales.validation;
    if (validation && validation.location) {
      return validation.location.replace(':attribute', field);
    }
    return `Invalid selection for ${field}`;
  },
  validate: function(value) {
    // console.log('RAW: ', value);
    let parsed;
    try {
      parsed = JSON.parse(value);
    } catch (err) {
      return false; // invalid JSON
    }
    // console.log('PARSED: ', parsed);

    const model = parsed.model || [];
    const phrase = parsed.phrase || '';

    // Fail if no selected items
    if (model.length === 0) return false;

    // Fail if user typed something but didn't pick
    if (phrase.trim() !== '') return false;

    // Call backend to validate selected IDs
    return fetch('/api/locations/validate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ids: model.map(i => i.id) })
    })
      .then(res => res.json())
      .then(data => data.valid === true)
      .catch(() => false);
  }
});

Validator.extend('attach_autocomplete', {
  getMessage: field => window.app.locales.validation.attach_autocomplete.replace(":attribute", field),
  validate: value => {
    var regex = new RegExp("^[0-9]*$");
    return regex.test(value);
  }
});

Validator.extend('model_date', {
  getMessage: field => window.app.locales.validation.model_date.replace(":attribute", field),
  validate: value => {
    var regex = /^\s*(3[01]|[12][0-9]|0?[1-9])-(1[012]|0?[1-9])-((?:19|20)\d{2})\s*$/;
    return regex.test(value);
  }
});

Validator.extend('phone_number', {
  getMessage: field => window.app.locales.validation.phone_number.replace(":attribute", field),
  validate: value => {

    if (value.toString().length < 9) {
      return false;
    }
    var regex = /^\+?([0-9])+-?[0-9]((-[0-9]+)?)+\.?$/;
    return regex.test(value);
  }
});

Validator.extend('tel', {
  getMessage: field => window.app.locales.validation.tel.replace(":attribute", field),
  validate: value => {

    if (value.toString().length < 9) {
      return false;
    }
    var regex = /^\+?([0-9])+?[0-9](([0-9]+)?)$/;
    return regex.test(value);
  }
});

Validator.extend('fax_number', {
  getMessage: field => window.app.locales.validation.fax_number.replace(":attribute", field),
  validate: value => {

    if (value.toString().length < 10) {
      return false;
    }
    var regex = /^\+?([0-9])+-?[0-9]((-[0-9]+)?)+$/;
    return regex.test(value);
  }
});
let methods = {
  np: function (accessor, defaultValue) {
    try {
      return accessor()
    } catch (error) {
      if (error instanceof TypeError) {
        if (typeof defaultValue !== 'undefined') {
          return defaultValue;
        }
        return;
      }
      throw error
    }
  },
  getMetadata: function (key) {
    let filtered = this.metadata.filter(index => index.key === key)
    return _.zipObject(filtered.map(item => item.id), filtered.map(item => item.value))
  },
  validate: function (event, scope = null) {
    this.$validator.validateAll(scope).then((result) => {
      // console.log(result, this.$validator.errors);
      if (result) {
        return;
      }
      this.$emit('validation-error', this.$validator.errors);
      event.preventDefault();
      sweetalert(window.app.locales.common.error, window.app.locales.subscriptions.form_with_errors, 'error');
    });
  },
  extractServerError: function (errOrXhr) {
    var locales = (window.app && window.app.locales) || {};
    var common = locales.common || {};
    var title = common.error || '';
    var generic = common.something_went_wrong || common.error || '';
    if (typeof errOrXhr === 'string' && errOrXhr) {
      return { kind: 'unknown', title: title, message: errOrXhr, code: 'unknown_error', status: 0, fieldErrors: null, redirectUrl: null };
    }
    var xhr = null;
    if (errOrXhr && typeof errOrXhr === 'object') {
      if (errOrXhr.xhr) xhr = errOrXhr.xhr;
      else if (typeof errOrXhr.status === 'number') xhr = errOrXhr;
    }
    var status = (xhr && typeof xhr.status === 'number') ? xhr.status : 0;
    var body = (xhr && xhr.responseJSON) || {};
    var fieldErrors = (body.errors && typeof body.errors === 'object') ? body.errors : null;
    var firstFieldMsg = null;
    if (fieldErrors) {
      for (var k in fieldErrors) {
        if (Object.prototype.hasOwnProperty.call(fieldErrors, k) && fieldErrors[k] && fieldErrors[k].length) {
          firstFieldMsg = fieldErrors[k][0];
          break;
        }
      }
    }
    var serverMsg = body.error || body.error_message || body.message || firstFieldMsg || null;
    var redirectUrl = body.url || body.redirect || null;
    var kind, message, code;
    if (status === 422) {
      kind = 'validation';
      message = serverMsg || generic;
      code = body.code || 'validation_failed';
    } else if (status === 403) {
      kind = 'forbidden';
      message = serverMsg || common.no_action_permission || generic;
      code = body.code || 'forbidden';
    } else if (status === 419) {
      kind = 'session_expired';
      message = serverMsg || common.session_expired || generic;
      code = 'session_expired';
    } else if (status === 0) {
      kind = 'network';
      message = common.network_unreachable || generic;
      code = 'network_unreachable';
    } else if (status >= 500) {
      kind = 'server';
      message = serverMsg || generic;
      code = body.code || 'server_error';
    } else {
      kind = 'unknown';
      message = serverMsg || generic;
      code = body.code || 'unknown_error';
    }
    return { kind: kind, title: title, message: message, code: code, status: status, fieldErrors: fieldErrors, redirectUrl: redirectUrl };
  },
  sendForm: function (form, scope, redirect) {
    if (scope) {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll(scope).then(isValid => {
          if (isValid) {
            let postData = $(form).serializeArray();
            let action = form.action;
            $.ajax({
              url: action,
              type: "POST",
              data: postData,
              cache: false,
              success: function (data) {
                resolve(data);
              },
              error: function (xhr) {
                var payload = { kind: 'xhr_error', xhr: xhr };
                payload.toString = function () {
                  try {
                    if (window.app && typeof window.app.extractServerError === 'function') {
                      return window.app.extractServerError(this).message;
                    }
                  } catch (_e) { /* fall through */ }
                  var c = (window.app && window.app.locales && window.app.locales.common) || {};
                  return c.something_went_wrong || c.error || '';
                };
                reject(payload);
              }
            });
          } else {
            this.$emit('validation-error', this.$validator.errors);
            reject('The form contain errors.' + '\n' + this.$validator.errors.items[0].msg);
          }
        }, error => {
          reject('The form contain errors!');
        });
      });
    } else {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            let postData = $(form).serializeArray();
            if (redirect) {
              postData.push({ name: 'submit', value: 'save_and_redirect' });
              postData.push({ name: 'qp', value: "" + window.location.search.substring(1) });
            }
            let action = form.action;
            $.ajax({
              url: action,
              type: "POST",
              data: postData,
              cache: false,
              success: function (data) {
                resolve(data);
              },
              error: function (xhr) {
                var payload = { kind: 'xhr_error', xhr: xhr };
                payload.toString = function () {
                  try {
                    if (window.app && typeof window.app.extractServerError === 'function') {
                      return window.app.extractServerError(this).message;
                    }
                  } catch (_e) { /* fall through */ }
                  var c = (window.app && window.app.locales && window.app.locales.common) || {};
                  return c.something_went_wrong || c.error || '';
                };
                reject(payload);
              }
            });
          } else {
            this.$emit('validation-error', this.$validator.errors);
            reject('The form contain errors.' + '\n' + this.$validator.errors.items[0].msg);
          }
        }, error => {
          reject('The form contain errors!');
        });
      });
    }

  },

  saveAndShowAlert: function (event, scope) {
    event.preventDefault();

    $('.edit-facility').each(function () {
      if (!$(this).parent().is(":hidden")) {
        $(this).find('[type="submit"]').first().click();
      }
    });
    this.sendForm(event.target, scope).then(response => {
      this.shouldReloadOnCloseModal = true;
      this.$emit('saveAndShowFinished', response);
      sweetalert(window.app.locales && window.app.locales.common && window.app.locales.common.success, window.app.locales && window.app.locales.common && window.app.locales.common.data_has_been_updated, 'success').then(value => {
        if (response.redirect) {
          window.location.href = response.redirect;
        }
      });
    }, err => {
      var detail = this.extractServerError(err);
      sweetalert(detail.title, detail.message, 'error');
    })
  },

  saveBookingAndShowConfirmAlert: function (event, scope, confirmationText, redirect) {
    event.preventDefault();
    let that = this;
    this.$validator.validateAll(scope).then((isValid) => {
      if (isValid) {
        that.$root.$emit("uploading-started");
        var form = $('#' + scope);

        let uploadTarget = $(form).find('input[type="file"]');
        var data = new FormData();
        let postData = form.serializeArray();
        const submitButtons = document.querySelectorAll('[data-type="submitBtn"]');

        for (let i = 0; i < postData.length; i++) {
          data.append(postData[i].name, postData[i].value);
        }
        if (uploadTarget.length) {
          for (let i = 0; i < uploadTarget.length; i++) {
            if (uploadTarget[i].files.length) {
              for (let j = 0; j < uploadTarget[i].files.length; j++) {
                if (window.FileReader) {
                  let reader = new FileReader();
                  reader.readAsDataURL(uploadTarget[i].files[j]);
                }
                data.append(`document[${j}]`, uploadTarget[i].files[j]);
              }
            }
          }
        }

        submitButtons.forEach((button) => button.classList.add("disabled-state"));

        $.ajax({
          url: form.attr("action"),
          method: "post",
          data: data,
          enctype: "multipart/form-data",
          processData: false,
          contentType: false,
          cache: false,
          xhr: function () {
            var xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener("progress", function (evt) {
              if (evt.lengthComputable) {
                var percentComplete = ((evt.loaded / evt.total) * 100);
                $(".progress-bar").width(parseInt(percentComplete) + '%');
                $(".progress-bar").html(parseInt(percentComplete) + '%');
              }
            }, false);
            return xhr;
          },
          success: function (result, textStatus, xhr) {
            document.querySelector(".js-loader-item").style.display = "none";
            that.$root.$emit("uploading-completed");

            if (result.error) {
              var err =
                result.error !== ""
                  ? result.error
                  : window.app.locales.common.error;
              sweetalert(window.app.locales.common.error, err, "error");
            } else {
              sweetalert(confirmationText, {
                buttons: [
                  window.app.locales.common && window.app.locales.common.stay_on_page,
                  window.app.locales.common && window.app.locales.common.go_to_my_bookings,
                ],
                dangerMode: true,
              }).then(value => {
                if (value) {
                  window.location.href = redirect;
                } else {
                  for (var i = 0; i < result.disabledDates.length; i++) {
                    window.app.disabledDates.push(result.disabledDates[i]);
                  }
                }
              });
            }

            if (scope == 'booking-widget-form') {
              window.app.$refs.booking_widget_form.clearForm();
            } else {
              window.app.$refs.booking_widget_form_m.clearForm();
            }

            submitButtons.forEach((button) => button.classList.remove("disabled-state"));
          },
          error: function (result) {
            document.querySelector(".js-loader-item").style.display = "none";
            this.$root.$emit("uploading-completed");
            sweetalert(
              window.app.locales.common.error,
              window.app.locales.common.error,
              "error"
            );
            submitButtons.forEach((button) => button.classList.remove("disabled-state"));
          },
        });
      } else {
        sweetalert(
          window.app.locales.common.error,
          window.app.locales.subscriptions.form_with_errors,
          "error"
        );
      }
    });
  },

  saveAndRedirect: function (event, scope) {
    event.preventDefault();
    $('.edit-facility').each(function () {
      if (!$(this).parent().is(":hidden")) {
        $(this).find('[type="submit"]').first().click();
      }
    });
    let form = $('body').find('#' + scope);
    if (form.length) {
      this.sendForm(form[0], null, true).then(response => {
        this.shouldReloadOnCloseModal = true;
        // console.log(window.app.locales.common);
        sweetalert(window.app.locales && window.app.locales.common && window.app.locales.common.success, window.app.locales && window.app.locales.common && window.app.locales.common.data_has_been_updated, 'success').then(value => {
          window.location.href = response;
        });
      }, err => {
        var detail = this.extractServerError(err);
        sweetalert(detail.title, detail.message, 'error');
      });
    }
  },
  logout() {
    this.$store.dispatch('authLogout').then(() => { });
  },
  toggleProfileNav(e) {
    var opener = this.$refs.profileNavOpener;
    var openerMobile = this.$refs.profileNavOpenerMobile;
    var nav = this.$refs.profileNav;
    var target = e.target;

    if (opener) {
      if (opener === target || opener.contains(target)) {
        this.profileNavState = !this.profileNavState;
      } else if (openerMobile === target || openerMobile.contains(target)) {
        this.profileNavState = !this.profileNavState;
      } else if (nav !== target && !nav.contains(target)) {
        this.profileNavState = false;
      }
    }
  },
  // toggleLangSelector() {
  //   this.$store.commit('TOGGLE_LANG_MENU');
  // },
  scrollToCardPublic: function (event) {
    let body = $('html, body');
    let link = event.target;
    let links = document.querySelectorAll('.nav-link');

    [...links].forEach(function (item) {
      item.classList.remove('current');
    });

    if (link.classList) {
      link.classList.add('current');
    }

    let navbarHeight = link.closest('.navbar.sticky').clientHeight;
    let arr = link.getAttribute('data-id').split('_');
    let target = arr[0] + arr[1];
    let duration = 700;
    if ($(window).width() < 767) {
      body.animate({
        scrollTop: $(target).offset().top,
      }, duration);
    } else {
      body.animate({
        scrollTop: $(target).offset().top - navbarHeight,
      }, duration);
    }
  },
  emitEvent(event) {
    this.$emit(event);
  },
  showLoader() {
    $('.js-loader-item').show();
  },
  hideLoader() {
    $('.js-loader-item').hide();
  },
  isTouchDevice: function () {
    if ('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch) {
      var el = document.getElementById('page-top');
      if (el) {
        el.classList.add('touch-device');
      }

      return true;
    }

    return false;
  },
  resetLoginModal() {
    this.$refs['login_modal_element'].backToLogin();
  },
  toggleUserMenu() {
    this.userMenu = !this.userMenu;
    if (this.userMenu) {
      document.addEventListener('click', this.handleUserMenuClickOutside, true);
      document.documentElement.classList.add('user-menu-open');
      document.body.classList.add('user-menu-open');
    } else {
      document.removeEventListener('click', this.handleUserMenuClickOutside, true);
      document.documentElement.classList.remove('user-menu-open');
      document.body.classList.remove('user-menu-open');
    }
  },
  handleUserMenuClickOutside(event) {
    if (this.$refs.userBtnRef && this.$refs.userBtnRef.contains(event.target)) return;
    if (!this.$refs.userMenuRef.contains(event.target)) {
      this.userMenu = false;
      document.removeEventListener('click', this.handleUserMenuClickOutside, true);
      document.documentElement.classList.remove('user-menu-open');
      document.body.classList.remove('user-menu-open');
    }
  }
};

window.app = _.merge(window.app, {
  el: '#page',
  store,
  computed: {
    ...mapGetters(['locale', 'locales', 'metadata']),
    error() {
      return this.$store.getters.getAuthError;
    },
    user() {
      return this.$store.getters.getAuthUser;
    },
    page() {
      return this.$store.getters.getPropertiesPage;
    },
    profileToggleClass() {
      return { 'profile-nav_active': this.profileNavState };
    }
  },
  methods: {
    ...mapActions(['fetchAppMetadata', 'fetchAppLocales']),
    ...methods
  },
  data: Object.assign({
    name: 'AtHome',
    isMapRendered: false,
    isDetailMapRendered: false,
    searchesMap: false,
    shouldReloadOnCloseModal: false,
    availableLocales: [
      {
        code: 'en',
        name: 'English'
      },
      {
        code: 'nl',
        name: 'Dutch'
      }
    ],
    grid: false,
    ready: false,
    navigationOpen: false,
    profileNavState: false,
    userMenu: false
  }, window.methods ? window.methods : {}),
  created() {
    this.fetchAppMetadata();
    this.fetchAppLocales();
    this.ready = true;
    document.addEventListener('click', this.toggleProfileNav);
  },
  destroyed() {
    document.removeEventListener('click', this.toggleProfileNav);
    document.removeEventListener('click', this.handleUserMenuClickOutside, true);
    document.documentElement.classList.remove('user-menu-open');
    document.body.classList.remove('user-menu-open');
  },
});
window.app = new Vue(window.app);

let boundMethods = {};
for (let methodName in methods) {
  boundMethods[methodName] = methods[methodName].bind(window.app);
}

window.app.methods = boundMethods;
window.app.sweetalert = sweetalert;
import Siema from 'siema';

_.each(document.querySelectorAll('.siema'), (item) => {
  let bullets = [];
  if (document.querySelectorAll('.siema__slide').length) {
    let siema = new Siema({
      selector: item.querySelector('.siema__slides'),
      duration: 200,
      easing: 'ease-out',
      perPage: 1,
      startIndex: 0,
      draggable: true,
      threshold: 20,
      onInit() {
        bullets = item.querySelector('.siema__bullets');

        bullets.children[this.currentSlide].classList.add('siema__bullet--is-active');

        _.each(bullets.children, (bullet, index) => {
          bullet.addEventListener('click', (event) => {
            this.goTo(index);
          });
        });

        let node;

        node = document.querySelector('.siema__arrow--prev');
        if (node) {
          node.addEventListener('click', () => {
            this.prev();
          });
        }

        node = document.querySelector('.siema__arrow--next');
        if (node) {
          node.addEventListener('click', () => {
            this.next();
          });
        }

        // Right-click deterrence consolidated into modules/property-photo-protection.js
        // (delegated on .js-protected-property-photo). The old #slidesHolder handler targeted a
        // non-existent element and threw when the slider had no such holder.
      },
      onChange() {
        _.each(bullets.children, (item) => {
          item.classList.remove('siema__bullet--is-active');
        });

        bullets.children[this.currentSlide].classList.add('siema__bullet--is-active');
      },
    });
  }
});

import Velocity from 'velocity-animate';
import Echo from 'laravel-echo';
// import Vue from 'vue';

document.querySelector('body').addEventListener('click', (event) => {
  if (
    !event.target.classList.contains('swal-overlay') &&
    (
      !document.querySelector('.swal-overlay') ||
      document.querySelector('.swal-overlay') && !document.querySelector('.swal-overlay').contains(event.target)
    )
  ) {
    let modals = document.querySelectorAll('[data-feature=\'modal\']:not([class="modal modal-code"])');
    let page = document.getElementById('page');

    var modal = event.target;
    if ($(modal).data('bs.modal')) {
      Velocity(modal, {
        opacity: 0,
      }, { display: 'none' });
      $(modal).modal('hide');
      if ($(modal).data('name') == 'confirm') {
        var searchUrl = location.search;
        var urlValue = document.location.href;
        if (searchUrl.includes('action=')) {
          if (searchUrl.includes('vip=1')) {
            urlValue = urlValue.replace(searchUrl, '?vip=1');
          } else {
            urlValue = urlValue.replace(searchUrl, '');
          }
          window.location.href = urlValue;
        }
      }
    }
    var count = 0;
    _.each(modals, (modal) => {
      if ($(modal).data('bs.modal') && $(modal).data('bs.modal').isShown) {
        count++;
      }
    });
    if (count == 0) {
      page.classList.remove("z-index");
    }
  }
});

// init modals
document.addEventListener('click', function (event) {
  let modalTrigger = event.target.closest('[data-feature="open-modal"]');
  if (!modalTrigger) return;

  event.stopPropagation();

  let modal = document.querySelector(`[data-feature="modal"][data-name="${modalTrigger.dataset.target}"]`);
  let page = document.getElementById('page');
  page.classList.add("z-index");

  Velocity(modal, { opacity: 1 }, { display: 'flex' });
  $(modal).modal('show');
});

document.addEventListener('click', function (event) {
  let modalCloseTrigger = event.target.closest('[data-feature="close-modal"]');
  if (!modalCloseTrigger) return;

  event.stopPropagation();

  let modal = document.querySelector(`[data-feature="modal"][data-name="${modalCloseTrigger.dataset.target}"]`);
  let page = document.getElementById('page');
  page.classList.remove("z-index");

  Velocity(modal, { opacity: 0 }, { display: 'none' });
  $(modal).modal('hide');
});

document.addEventListener('click', (event) => {
  let modalContent = event.target.closest('[data-feature="modal-active-area"]');
  if (!modalContent) return;

  event.stopPropagation();
});

let tabsCollection = document.querySelectorAll('[data-feature=\'tabs\']');

_.each(tabsCollection, (tabs) => {
  _.each(tabs.children, (tab) => {
    if (!tab.classList.contains(tabs.dataset.activeItemClass) && tab.dataset.target) {
      document.querySelector('[data-name=\'' + tab.dataset.target + '\']').style.display = 'none';
    }

    tab.addEventListener('click', function (event) {
      _.each(tabs.children, (tab) => {
        tab.classList.remove(tabs.dataset.activeItemClass);

        if (tab.dataset.target) {
          Velocity(document.querySelector('[data-name=\'' + tab.dataset.target + '\']'), {
            opacity: 0,
          }, { display: 'none' });
        }
      });

      this.classList.add(tabs.dataset.activeItemClass);

      if (this.dataset.target) {
        Velocity(document.querySelector('[data-name=\'' + this.dataset.target + '\']'), {
          opacity: 1,
        }, { display: 'block' });
      }
    });
  });
});

function createDpiTestElements() {
  var getDpiHtmlStyle = 'data-dpi-test { height: 1in; left: -100%; position: absolute; top: -100%; width: 1in; }'

  var head = document.getElementsByTagName('head')[0]
  var getDPIElement = document.createElement('style')
  getDPIElement.setAttribute('type', 'text/css')
  getDPIElement.setAttribute('rel', 'stylesheet')
  getDPIElement.innerHTML = getDpiHtmlStyle
  head.appendChild(getDPIElement)

  var body = document.getElementsByTagName('body')[0]
  var dpiTestElement = document.createElement('data-dpi-test')
  dpiTestElement.setAttribute('id', 'dpi-test')
  body.appendChild(dpiTestElement)
}

function setActiveLink() {
  let body = $('html, body');
  let cards = body.find('.v-card');
  let links = body.find('.navbar.sticky a.nav-link');
  let cardsList = [];
  for (var i = 0; i < cards.length; i++) {
    let id = $(cards[i]).find('.v-card__vertical-position').attr('id');
    cardsList.push(id);
  }
  cardsList = cardsList.filter(Boolean); // prevent empty string in array

  function setActiveLinkOnScroll() {
    if (cardsList.length === 0) return;

    let firstCardPos = $('#' + cardsList[0]).offset().top + 1;
    let scrollTop = $(window).scrollTop() + 140;
    let scrollPos = firstCardPos > scrollTop ? firstCardPos : scrollTop;
    for (var i = 0; i < cardsList.length; i++) {
      if (cardsList.length == i + 1
        || $('#' + cardsList[i]).offset().top < scrollPos
        && $('#' + cardsList[i + 1]).offset().top >= scrollPos) {
        let current = links.filter('[href="#_' + cardsList[i] + '"]');
        links.removeClass('current');
        return current.addClass('current');
      }
    }
  }
  $(window).on('scroll', function () {
    setActiveLinkOnScroll();
  })
}

function toggleNav() {
  let navigation = document.querySelector('.func-navbar-nav');
  navigation.classList.toggle('opened');
}

function checkIfPCVersionEnabled() {
  //Detect if PC version is enabled in mobile browser
  if (window.outerWidth <= 767 && window.screen.width < window.innerWidth) {
    document.querySelector('body').classList.add('pc-version-is-enabled');
  }
}

$(document).ready(function () {


  setActiveLink();

  checkIfPCVersionEnabled();

  if ($('.sticky').length) {
    var h = $('.sticky').first().offset().top,
      items = document.querySelectorAll('.nav-link');

    // sticky navbar
    $(window).scroll(function () {
      publicScrollHandler();
    });

    function publicScrollHandler() {
      if (window.pageYOffset >= h) {
        $('.sticky').first().addClass('navbar-fixed');
        $('.func-nav-bar-stub').outerHeight($('.sticky').outerHeight(true));
        if ($('.sticky').length) {
          $('body').addClass('navbar-fixed--padding');
        }
      } else {
        $('.sticky').first().removeClass('navbar-fixed');
        $('.func-nav-bar-stub').removeAttr('style');
        $('body').removeClass('navbar-fixed--padding');
      }
    }

    if (location.hash) {
      [...items].forEach(function (item) {
        if (item.attributes.href.value == location.hash) {
          if (item.classList) {
            item.classList.add('current');
            return;
          }
        }
      });
    }
  }

  if (window.innerWidth < 767) {
    let element = document.querySelector('.func-nav-link');

    if (typeof (element) != 'undefined' && element != null) {
      element.addEventListener('click', toggleNav)
    }
  }

  // let $scrollTopBtn = $('.func-scroll-to-top-btn');
  //
  // $(window).scroll(function () {
  //   if ($(this).scrollTop() >= 200) {
  //     $scrollTopBtn.fadeIn();
  //   } else {
  //     $scrollTopBtn.fadeOut();
  //   }
  // });
  //
  // $(document).on('click', '.func-scroll-to-top-btn', function () {
  //   $('body,html').animate({
  //     scrollTop: 0
  //   }, 700);
  // });
});

// Card mini-slider mouse drag-to-scroll. Native scroll-snap already
// handles touch on mobile, so we let touch pointers fall through and
// only intercept mouse pointers. Used by the public listing page
// (.properties-item__slider, rendered by PropertiesListing.vue) and
// the homepage relevant-properties grid (.relevant-properties__item-
// slider, rendered by index.blade.php).
//
// Three browser quirks the handler has to fight:
//   1. Mouse-down on an <img> inside an <a> kicks off the browser's
//      native drag-and-drop. We block it with preventDefault on the
//      pointerdown and -webkit-user-drag: none on the images (SCSS).
//   2. scroll-snap-type: x mandatory tries to snap on every scrollLeft
//      change, which fights the drag. We disable snap on the slider
//      element for the duration of the drag and restore it on release
//      so the slider snaps to the nearest slide once the gesture ends.
//   3. If the pointer leaves the slider while moving, we'd lose the
//      events. setPointerCapture pins all subsequent pointer events to
//      the slider until pointerup/pointercancel.
(function () {
  var SLIDER_SELECTOR = '.properties-item__slider, .relevant-properties__item-slider, .property-gallery__mobile-snap';
  var DRAG_THRESHOLD = 5;
  var activeSlider = null;
  var capturedPointerId = null;
  var startX = 0;
  var scrollLeftStart = 0;
  var moved = false;
  var savedSnapType = '';
  var savedScrollBehavior = '';

  // rAF coalescing: pointermove can fire 100+ times per second, but the
  // browser only needs one scrollLeft write per frame. Writing on every
  // move event causes Chrome to jank in narrow/responsive viewports.
  var rafScheduled = false;
  var pendingScrollLeft = null;

  function flushScrollWrite() {
    rafScheduled = false;
    if (activeSlider && pendingScrollLeft !== null) {
      activeSlider.scrollLeft = pendingScrollLeft;
      pendingScrollLeft = null;
    }
  }

  function scheduleScroll(target) {
    pendingScrollLeft = target;
    if (rafScheduled) return;
    rafScheduled = true;
    requestAnimationFrame(flushScrollWrite);
  }

  // Snap to the nearest slide after a drag release. Chrome does not
  // retroactively snap when scroll-snap-type toggles back from 'none'
  // to 'mandatory', so a fractional scrollLeft can persist after the
  // drag ends. Use slides[idx].offsetLeft so subpixel math on
  // clientWidth never causes a miss.
  function settleSnap(slider) {
    var slides = slider.children;
    if (!slides.length) return;
    var slideWidth = slider.clientWidth;
    if (slideWidth <= 0) return;
    var idx = Math.round(slider.scrollLeft / slideWidth);
    idx = Math.max(0, Math.min(slides.length - 1, idx));
    var target = slides[idx];
    var targetLeft = target ? target.offsetLeft : (idx * slideWidth);
    if (typeof slider.scrollTo === 'function') {
      slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
    } else {
      slider.scrollLeft = targetLeft;
    }
  }

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'touch') return;
    if (event.button !== 0) return;
    var slider = event.target.closest && event.target.closest(SLIDER_SELECTOR);
    if (!slider) return;
    activeSlider = slider;
    capturedPointerId = event.pointerId;
    startX = event.clientX;
    scrollLeftStart = slider.scrollLeft;
    moved = false;
    pendingScrollLeft = null;
    // Pause native scroll-snap so scrollLeft writes are not fought.
    savedSnapType = slider.style.scrollSnapType;
    savedScrollBehavior = slider.style.scrollBehavior;
    slider.style.scrollSnapType = 'none';
    slider.style.scrollBehavior = 'auto';
    // Suppress the browser-default <img> drag-and-drop and selection.
    event.preventDefault();
    try { slider.setPointerCapture(capturedPointerId); } catch (e) {}
  });

  document.addEventListener('pointermove', function (event) {
    if (!activeSlider) return;
    if (event.pointerId !== capturedPointerId) return;
    var dx = event.clientX - startX;
    if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
      moved = true;
    }
    if (moved) {
      event.preventDefault();
      scheduleScroll(scrollLeftStart - dx);
    }
  });

  function endPointerDrag(event) {
    if (!activeSlider) return;
    if (event && event.pointerId !== capturedPointerId) return;
    var slider = activeSlider;
    var wasMoved = moved;
    try { slider.releasePointerCapture(capturedPointerId); } catch (e) {}
    // Flush any pending rAF write so the final drag position is on
    // screen before we measure for snap settlement.
    if (rafScheduled) flushScrollWrite();
    // Restore snap/scroll-behaviour so the slider eases to the nearest
    // slide and inline navigation feels natural again.
    slider.style.scrollSnapType = savedSnapType;
    slider.style.scrollBehavior = savedScrollBehavior;
    activeSlider = null;
    capturedPointerId = null;
    pendingScrollLeft = null;
    if (wasMoved) {
      // Suppress the upcoming click so the parent <a href> doesn't
      // navigate to the property detail page after a drag gesture.
      var suppress = function (clickEvent) {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        document.removeEventListener('click', suppress, true);
      };
      document.addEventListener('click', suppress, true);
      // Explicit snap-to-nearest after the type toggle so the slider
      // never sits parked on a fractional scrollLeft.
      settleSnap(slider);
    }
  }

  document.addEventListener('pointerup', endPointerDrag);
  document.addEventListener('pointercancel', endPointerDrag);
})();

(function () {
  // Global client-error capture. Sends a small, PII-stripped payload to the
  // server-side sink (/api/client-error). Defence in depth: the server-side
  // controller re-redacts as well. Never blocks the UI. No vendor dependency.
  var SINK    = '/api/client-error';
  var MAX_PER_WINDOW = 10;
  var WINDOW_MS      = 5000;
  var sentTimes      = [];

  function redact(s) {
    if (typeof s !== 'string' || s === '') return s;
    return s
      .replace(/\b[\w._%+\-]+@[\w.\-]+\.[A-Za-z]{2,}\b/g, '[email]')
      .replace(/\b[A-Z]{2}\d{2}[A-Z0-9]{11,30}\b/g, '[iban]')
      .replace(/\b\d{4}\s?[A-Za-z]{2}\b\s*\d{1,5}[A-Za-z]?\b/g, '[address]')
      .replace(/\b\d{4}\s?[A-Za-z]{2}\b/g, '[postcode]')
      .replace(/\b\d{3}[\s\-]?\d{2}[\s\-]?\d{4}\b/g, '[bsn]')
      .replace(/\+?\d[\d\s\-().]{8,}\d/g, '[phone]');
  }

  function rateOk() {
    var now = Date.now();
    sentTimes = sentTimes.filter(function (t) { return now - t < WINDOW_MS; });
    if (sentTimes.length >= MAX_PER_WINDOW) return false;
    sentTimes.push(now);
    return true;
  }

  function getCsrf() {
    var m = document.querySelector('meta[name="csrf-token"]');
    return m ? m.getAttribute('content') : '';
  }

  function send(payload) {
    if (! rateOk()) return;
    try {
      var safe = {};
      ['message','source','stack','url','ua','session_hint','captured_at'].forEach(function (k) {
        if (payload[k] != null) safe[k] = redact(String(payload[k]));
      });
      ['lineno','colno'].forEach(function (k) {
        if (typeof payload[k] === 'number') safe[k] = payload[k];
      });
      if (! safe.message) return;
      var body = JSON.stringify(safe);
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/json' });
        navigator.sendBeacon(SINK, blob);
        return;
      }
      fetch(SINK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': getCsrf() },
        body: body,
        keepalive: true,
        credentials: 'same-origin'
      });
    } catch (_e) { /* swallow */ }
  }

  function payloadFromError(err, source, lineno, colno) {
    return {
      message:      (err && (err.message || String(err))) || 'unknown',
      source:       source || (err && err.fileName) || '',
      lineno:       typeof lineno === 'number' ? lineno : (err && err.lineNumber) || 0,
      colno:        typeof colno  === 'number' ? colno  : (err && err.columnNumber) || 0,
      stack:        (err && err.stack) || '',
      url:          (window.location && window.location.href) || '',
      ua:           (navigator && navigator.userAgent) || '',
      captured_at:  new Date().toISOString()
    };
  }

  window.addEventListener('error', function (event) {
    send(payloadFromError(event.error || new Error(event.message || ''), event.filename, event.lineno, event.colno));
  });

  window.addEventListener('unhandledrejection', function (event) {
    var r = event && event.reason;
    var asErr = r && r.message ? r : new Error(r ? String(r) : 'unhandled rejection');
    send(payloadFromError(asErr, '', 0, 0));
  });

  if (typeof window.Vue !== 'undefined' && window.Vue && window.Vue.config) {
    var prev = window.Vue.config.errorHandler;
    window.Vue.config.errorHandler = function (err, vm, info) {
      var p = payloadFromError(err, '', 0, 0);
      p.message = (info ? '[Vue:' + info + '] ' : '[Vue] ') + (p.message || '');
      send(p);
      if (typeof prev === 'function') {
        try { prev(err, vm, info); } catch (_e) {}
      }
    };
  }
})();

